import { CloseButton, Table } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useState } from 'react';
import { TableRowCollapsible } from '../../../components/TableRowCollapsible';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import {
	formatToCurrency,
	formatToDateString,
	formatToTimeString,
} from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import { Receipt } from '../../receipts/Receipt';
import type { ReceiptDto } from '../types/ReceiptDto';
import { KeyedRow } from '../../../components/KeyedRow';

interface TableRowProps {
	receipt: ReceiptDto;
}

export function SalesViewerTableRow({ receipt }: TableRowProps) {
	const [receiptOpen, setReceiptOpen] = useState(false);

	return (
		<>
			<KeyedRow>
				<Table.Td>{receipt.id}</Table.Td>
				<Table.Td>{formatToDateString(receipt.dateTime)}</Table.Td>
				<Table.Td>{formatToTimeString(receipt.dateTime)}</Table.Td>
				<Table.Td>{undefinedCheck(receipt.branch)}</Table.Td>
				<Table.Td>{receipt.receiptNumber}</Table.Td>
				<Table.Td>{receipt.operatorName}</Table.Td>
				<Table.Td>{formatToCurrency(receipt.grossSale)}</Table.Td>
				<Table.Td>{formatToCurrency(receipt.totalAmount)}</Table.Td>
				<Table.Td>{formatToCurrency(receipt.vat)}</Table.Td>
				<Table.Td>{formatToCurrency(receipt.discount)}</Table.Td>
				<Table.Td>
					<CloseButton
						icon={
							!receiptOpen ? (
								<IconChevronDown {...defaultIconStyle} />
							) : (
								<IconChevronUp {...defaultIconStyle} />
							)
						}
						onClick={() => setReceiptOpen(!receiptOpen)}
					/>
				</Table.Td>
			</KeyedRow>
			<TableRowCollapsible isOpen={receiptOpen}>
				<Receipt id={receipt.id} startLoading={receiptOpen} />
			</TableRowCollapsible>
		</>
	);
}
